<template>
  <action-dispatcher v-if="isPortal" action="portal/getContents">
    <component :is="resolved" />
  </action-dispatcher>
  <component v-else :is="resolved" />
</template>

<script>
import { mapGetters, mapState } from "vuex";
import get from "lodash/get";
import Home from "./Home.vue";
import EbookHome from "./EbookHome.vue";
import PortalHome from "./PortalHome.vue";

export default {
  name: "HomeRouter",
  computed: {
    ...mapState(["setup", "activeContentProductId"]),
    ...mapGetters(["isPortal"]),
    ...mapGetters("portal", ["activeContent"]),
    typeProduct() {
      if (this.isPortal) {
        return get(this.activeContent, "type_product");
      }

      return get(this.setup, "type_product");
    },
    resolved() {
      if (this.isPortal && !this.activeContentProductId) {
        return PortalHome;
      }

      return this.typeProduct === "ebook" ? EbookHome : Home;
    }
  }
};
</script>
